/**
 * Public Profile Statistics Service
 * API service for fetching public profile statistics (Active + Upcoming rituals only)
 * Used for profile/other profile pages
 */

import { apiClient } from "@/lib/api-client"
import type { PublicProfileStatisticsResponse } from "../types/profile.types"

/**
 * Get public profile statistics
 * @param userId - The user ID to fetch statistics for
 * @returns Public profile statistics response with Active + Upcoming teachings, practicing, and communities counts
 */
export const getPublicProfileStatistics = async (
  userId: string,
): Promise<PublicProfileStatisticsResponse> => {
  const response = await apiClient.get(`/api/profiles/${userId}/public-statistics`)
  return response.data
}
